import { SUBSCRIPTION_STATUS } from '_utils/constants'

export const checkSubscriptionExpired = user =>
  !user.skipSubscription &&
  (!user.subscriptionStatus || SUBSCRIPTION_STATUS.CANCELED === user.subscriptionStatus) &&
  !user.belongsToACompany
